import { ApiResource } from '@/core/models/api-resource.interface';
import { UnavailableType } from './unavailable-type.interface';

export class UnavailableTypeService {
   async get() {
      return await api.get<ApiResource<UnavailableType>>('/unavailable-type', cacheFirstConfig).then((response) => response?.data);
   }
}
